import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ExtratoContaBmpService {

  constructor(
    private http: HttpService,
  ) { }

  buscaExtratoBmp(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/extrato/bmp', data, successHandle, errorHandle);

  }
}
